import { IScaffoldActionPreviewColWidthChange, ScaffoldState } from "./interface";

/**
 * Handles the PREVIEW_COL_WIDTH_CHANGE action by storing or clearing a transient
 * column width override used during a resize drag session.
 *
 * When width is null, the entry for colId is removed from previewColWidths.
 * When width matches the existing value, the state is returned unchanged.
 * Otherwise, the new width is merged into previewColWidths.
 *
 * @param action - The PREVIEW_COL_WIDTH_CHANGE action carrying the colId and new width (or null to clear).
 * @param state - The current scaffold state.
 * @returns Updated scaffold state with the preview width applied or removed.
 */
export const scr_previewColWidthChange = <T>(
  action: IScaffoldActionPreviewColWidthChange,
  state: ScaffoldState<T>,
): ScaffoldState<T> => {
  if (action.width === null) {
    if (!(action.colId in state.previewColWidths)) {
      return state;
    }

    const { [action.colId]: _removed, ...remaining } = state.previewColWidths;
    return { ...state, previewColWidths: remaining };
  }

  if (state.previewColWidths[action.colId] === action.width) {
    return state;
  }

  return {
    ...state,
    previewColWidths: { ...state.previewColWidths, [action.colId]: action.width },
  };
};
